import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { User, Users, Layers, Network as NetworkIcon, Globe } from "lucide-react";

const OPTIONS = [
  { label: "Send to One Driver", icon: User },
  { label: "Send to Selected Drivers", icon: Users },
  { label: "Send to Driver Group", icon: Layers },
  { label: "Send to Eligible Network", icon: NetworkIcon },
  { label: "Public Marketplace", icon: Globe },
];

export const BrokerSendJobs = () => (
  <section data-testid="broker-send-jobs-section" className="py-24 md:py-28 bg-white">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="Direct Opportunities" title="Send the Right Opportunity to the Right Drivers." testId="broker-send-jobs" />
      <RevealStagger className="mt-10 grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {OPTIONS.map((o) => (
          <RevealItem key={o.label}>
            <div data-testid={`broker-send-jobs-option-${o.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="h-full bg-rr-surface border border-rr-line rounded-xl p-5 text-center hover:border-rr-orange/50 transition-colors">
              <o.icon size={22} className="text-rr-orange mx-auto mb-3" />
              <p className="text-sm font-bold text-rr-navy">{o.label}</p>
            </div>
          </RevealItem>
        ))}
      </RevealStagger>
      <p className="text-xs text-rr-muted mt-6 max-w-xl">Private opportunities remain private unless the broker chooses otherwise.</p>
    </div>
  </section>
);
